import { render, staticRenderFns } from "./mock-record.vue?vue&type=template&id=7c1fc1f7&scoped=true&"
import script from "./mock-record.vue?vue&type=script&lang=js&"
export * from "./mock-record.vue?vue&type=script&lang=js&"
import style0 from "./mock-record.vue?vue&type=style&index=0&id=7c1fc1f7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1fc1f7",
  null
  
)

export default component.exports